export const USIBRAS_THEME = {
    name: 'usibras',
    base: null,
    variables: {

        empresa: 'USIBRAS'

    }
}